// Configuração por ambiente: lida UMA vez, aqui. Nenhum outro arquivo lê import.meta.env.

const env = import.meta.env;

export const config = {
  supabaseUrl: env.VITE_SUPABASE_URL ?? '',
  supabaseChaveAnon: env.VITE_SUPABASE_CHAVE_ANON ?? '',
  /** Base do link de rastreio enviado ao cliente. */
  urlPublica: env.VITE_URL_PUBLICA || globalThis.location?.origin || '',
  /** Estilo (MapLibre) do mapa do link de rastreio. Vazio = página sem mapa. */
  mapaEstiloUrl: env.VITE_MAPA_ESTILO_URL || null,
  /** Estilo para o esquema escuro; vazio = usa o claro nos dois. */
  mapaEstiloEscuroUrl: env.VITE_MAPA_ESTILO_ESCURO_URL || null,
} as const;

export const configPronta = Boolean(config.supabaseUrl && config.supabaseChaveAnon);
